import ApiConfig from "../../../config/api-config";
import { $apiClient } from "../../../utils/apiClient";

export function getLocale() {
  return $apiClient.get(`${ApiConfig.LOCALE}`);
}
